/**
 * Provides metadata about identity kind.
 */
export let IdentityKind;
/**
 * Provides metadata about permission level.
 */
(function (IdentityKind) {
  IdentityKind["All"] = "All";
  IdentityKind["Users"] = "Users";
  IdentityKind["Groups"] = "Groups";
  IdentityKind["OrganizationalUnits"] = "OrganizationalUnits";
  IdentityKind["UsersAndGroups"] = "UsersAndGroups";
  IdentityKind["UsersAndOrganizationalUnits"] = "UsersAndOrganizationalUnits";
  IdentityKind["GroupsAndOrganizationalUnits"] = "GroupsAndOrganizationalUnits";
})(IdentityKind || (IdentityKind = {}));
export let PermissionLevel;
/**
 * Type to provide an Object with the permission information that has to be set.
 */
(function (PermissionLevel) {
  PermissionLevel["AllowedOrDenied"] = "AllowedOrDenied";
  PermissionLevel["Allowed"] = "Allowed";
  PermissionLevel["Denied"] = "Denied";
})(PermissionLevel || (PermissionLevel = {}));
export const PermissionValues = {
  undefined: 0,
  allow: 1,
  deny: 2
};

// a key for permission values usage permissionKeys[0] will be undefined and so on
export const permissionKeys = Object.keys(PermissionValues);
/**
 * Provides metadata about permission inheritance.
 */
export let Inheritance;
(function (Inheritance) {
  Inheritance["Break"] = "break";
  Inheritance["Unbreak"] = "unbreak";
})(Inheritance || (Inheritance = {}));
//# sourceMappingURL=Security.js.map